let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("fDwDZ")]).then(() => parcelRequire('2I7c2'));